(function ($) {
	'use strict';

	$(function () {
		const $page = $('[data-jobs-page]');
		if (!$page.length) return;

		const baseUrl = $page.data('jobs-url') || window.location.pathname;
		const $forms = $('.js-jobs-form');
		const $heroForm = $('.jobs-search');
		const $filterForm = $('.jobs-filter-form');
		const $list = $('[data-jobs-list]');
		const $count = $('[data-jobs-count]');
		const $mobileCount = $('[data-jobs-mobile-count]');
		const $loadMore = $('[data-jobs-load-more]');
		const $endState = $('[data-jobs-end-state]');
		const $filters = $('[data-jobs-filters]');
		const $error = $('[data-jobs-error]');
		const $clearButtons = $('.js-jobs-clear');
		const loadMoreLabel = $page.data('label-load-more') || '';
		const loadingLabel = $page.data('label-loading') || '';
		let appliedSearchValue = new URLSearchParams(window.location.search).get('q') || '';
		let debounceTimer = null;
		let activeRequest = null;

		function measureTextWidth(texts, $source) {
			const canvas = measureTextWidth.canvas || (measureTextWidth.canvas = document.createElement('canvas'));
			const context = canvas.getContext('2d');
			const font = window.getComputedStyle($source[0]).font || '14px sans-serif';
			let width = 0;
			context.font = font;
			texts.forEach(function (text) {
				width = Math.max(width, context.measureText(String(text || '')).width);
			});
			return Math.ceil(width);
		}

		function setSortDropdownWidth($select, $dropdown) {
			if (!$select.closest('.jobs-sort').length) return;
			const texts = $select.find('option').map(function () {
				return $.trim($(this).text());
			}).get().filter(Boolean);
			const width = Math.max(150, measureTextWidth(texts, $dropdown.find('.dropdown-selected')) + 58);
			$dropdown.addClass('jobs-select-dropdown--content-width')
				.css('--jobs-select-content-width', width + 'px');
		}

		function initJobsSelects() {
			$('.jobs-page select').each(function () {
				const $select = $(this);
				if ($select.is('[data-city-autocomplete]')) return;
				if ($select.next('.jobs-select-dropdown').length) return;

				const $dropdown = $('<div class="custom-dropdown resume-select-dropdown employer-select-dropdown jobs-select-dropdown"></div>');
				const $selected = $('<div class="dropdown-selected"></div>');
				const $options = $('<ul class="dropdown-list text-[13px] bg-white dark:bg-slate-900 dark:shadow-gray-800"></ul>');

				$select.find('option').each(function () {
					const $option = $(this);
					$('<li></li>')
						.text($option.text())
						.attr('data-value', $option.val())
						.toggleClass('is-placeholder', !$option.val())
						.appendTo($options);
				});

				$select.addClass('employer-native-select');
				$dropdown.append($selected, $options).insertAfter($select);
				setSortDropdownWidth($select, $dropdown);

				$dropdown.on('mousedown click', function (event) {
					event.stopPropagation();
				});

				$selected.on('click', function (event) {
					event.preventDefault();
					$('.jobs-select-dropdown .dropdown-list').not($options).hide();
					$options.toggle();
				});

				$options.on('click', 'li', function (event) {
					event.preventDefault();
					if ($(this).hasClass('is-disabled')) return;
					$select.val($(this).attr('data-value')).trigger('change');
					$options.hide();
				});

				$select.on('change', refreshJobsSelects);
			});

			refreshJobsSelects();
		}

		function refreshJobsSelects() {
			$('.jobs-page select').each(function () {
				const $select = $(this);
				if ($select.is('[data-city-autocomplete]')) return;
				const value = $select.val();
				const text = $select.find('option:selected').text() || $select.find('option:first').text();
				const $dropdown = $select.next('.jobs-select-dropdown');
				$dropdown.find('.dropdown-selected').text(text);
				$dropdown.find('li').removeClass('is-active')
					.filter(function () {
						return String($(this).attr('data-value')) === String(value);
					})
					.addClass('is-active');
				$dropdown.find('li').each(function () {
					const optionValue = String($(this).attr('data-value'));
					const disabled = $select.find('option[value="' + optionValue + '"]').prop('disabled');
					$(this).toggleClass('is-disabled', !!disabled);
				});
			});
		}

		function collectParams(extra, options) {
			const params = new URLSearchParams();
			const multi = {};
			const includePendingSearch = !!(options && options.includePendingSearch);

			$forms.find(':input[name]').each(function () {
				if (this.disabled || !this.name) return;
				if ((this.type === 'checkbox' || this.type === 'radio') && !this.checked) return;

				let value = $(this).val();
				const name = this.name.endsWith('[]') ? this.name.slice(0, -2) : this.name;
				if (this.name === 'q' && !includePendingSearch) {
					value = appliedSearchValue;
				}
				if (value === null || value === '') return;

				if (this.name.endsWith('[]')) {
					if (!multi[name]) multi[name] = [];
					multi[name].push(value);
				} else {
					params.set(name, value);
				}
			});

			Object.keys(multi).forEach(function (name) {
				params.set(name, multi[name].join(','));
			});

			const sort = $('[data-jobs-sort]').val();
			if (sort && sort !== 'newest') {
				params.set('sort', sort);
			} else {
				params.delete('sort');
			}

			if (extra) {
				Object.keys(extra).forEach(function (key) {
					if (extra[key] !== null && extra[key] !== '') params.set(key, extra[key]);
				});
			}

			return params;
		}

		function paramsUrl(params) {
			const query = params.toString().replace(/%2C/g, ',');
			return baseUrl + (query ? '?' + query : '');
		}

		function fragmentUrl(params) {
			const fragmentParams = new URLSearchParams(params.toString());
			fragmentParams.set('_fragment', '1');
			return paramsUrl(fragmentParams);
		}

		function syncSharedFields(source) {
			if (!source.name || source.name.endsWith('[]')) return;

			const value = $(source).val();
			$forms.find('[name="' + source.name + '"]').not(source).each(function () {
				$(this).val(value);
				if ($(this).is('[data-city-autocomplete]')) {
					$(this).trigger('change.cityAutocomplete');
				}
			});
			refreshJobsSelects();
		}

		function isClearable() {
			const params = collectParams();
			params.delete('sort');
			params.delete('page');
			return Array.from(params.keys()).length > 0;
		}

		function updateClearState() {
			const active = isClearable();
			$clearButtons.prop('disabled', !active).toggleClass('is-disabled', !active);
		}

		function setLoading(isLoading) {
			$list.toggleClass('is-loading', isLoading);
			$loadMore.prop('disabled', isLoading);
		}

		function updateLoadMore(hasMore, nextPage) {
			$loadMore.attr('data-next-page', nextPage || '');
			$loadMore.prop('disabled', false).text(loadMoreLabel).toggleClass('is-hidden', !hasMore);
			$endState.toggleClass('is-hidden', !!hasMore || $list.find('.job-card').length === 0);
		}

		function renderResponse(response, append) {
			if (append) {
				const $items = $(response.html).addClass('is-new');
				$list.append($items);
				window.requestAnimationFrame(function () {
					$items.removeClass('is-new');
				});
			} else {
				$list.html(response.html);
				$list.find('.job-card').addClass('is-new');
				window.requestAnimationFrame(function () {
					$list.find('.job-card').removeClass('is-new');
				});
			}

			$count.text(response.count);
			$mobileCount.text(response.count);
			updateLoadMore(response.has_more, response.next_page, append);
			updateClearState();
			applyAvailability(response.available || {});
			renderSkillChips();
		}

		function loadJobs(options) {
			const append = !!(options && options.append);
			const push = !options || options.push !== false;
			const params = collectParams(append ? {page: $loadMore.attr('data-next-page')} : null, options);
			const url = paramsUrl(params);
			const requestUrl = fragmentUrl(params);

			if (activeRequest) activeRequest.abort();
			$error.removeClass('is-visible');
			setLoading(true);
			if (append) $loadMore.text(loadingLabel);

			activeRequest = $.ajax({
				url: requestUrl,
				type: 'GET',
				dataType: 'json',
				headers: {'X-Requested-With': 'XMLHttpRequest'}
			}).done(function (response) {
				renderResponse(response, append);
				if (push) window.history.pushState({url: url}, '', url);
			}).fail(function (xhr, status) {
				if (status !== 'abort') $error.addClass('is-visible');
			}).always(function () {
				activeRequest = null;
				setLoading(false);
			});
		}

		function setControlsFromParams(params) {
			clearControls();

			$forms.find(':input[name]').each(function () {
				const name = this.name.endsWith('[]') ? this.name.slice(0, -2) : this.name;
				const values = params.getAll(name).concat(params.getAll(this.name)).flatMap(function (value) {
					return String(value).split(',');
				});

				if (this.type === 'checkbox' || this.type === 'radio') {
					this.checked = values.includes(this.value);
				} else {
					$(this).val(params.get(name) || params.get(this.name) || '');
				}
			});

			$('[data-jobs-sort]').val(params.get('sort') || 'newest');
			appliedSearchValue = params.get('q') || '';
			refreshJobsSelects();
			renderSkillChips();
			updateClearState();
		}

		function clearControls() {
			$forms.find(':input[name]').each(function () {
				$(this).prop('disabled', false);

				if (this.type === 'checkbox' || this.type === 'radio') {
					this.checked = false;
				} else {
					$(this).val('');
				}
			});

			$forms.find('select[data-city-autocomplete="select"]').val('').trigger('change.cityAutocomplete');

			$filterForm.find('option').prop('disabled', false);
			$filterForm.find('.jobs-check, .jobs-select-dropdown .dropdown-list li').removeClass('is-disabled');
		}

		function clearFilters() {
			clearControls();
			$('[data-jobs-sort]').val('newest');
			appliedSearchValue = '';
			$('[data-jobs-skill-search]').val('');
			$('[data-jobs-skill-options]').removeClass('is-open').find('[data-skill-name]').show();
			refreshJobsSelects();
			renderSkillChips();
			window.history.pushState({url: baseUrl}, '', baseUrl);
			loadJobs({push: false});
		}

		function renderSkillChips() {
			const $chips = $('[data-jobs-skill-chips]');
			if (!$chips.length) return;

			$chips.empty();
			$('[data-jobs-skill-options] input[name="skills[]"]:checked').each(function () {
				const $input = $(this);
				$('<button type="button" class="jobs-skill-chip"></button>')
					.attr('data-skill-id', $input.val())
					.text($input.siblings('span').text())
					.append($('<i class="uil uil-times"></i>'))
					.appendTo($chips);
			});

			$chips.toggleClass('is-empty', !$chips.children().length);
		}

		function applyAvailability(available) {
			Object.keys(available).forEach(function (name) {
				const values = (available[name] || []).map(String);
				$filterForm.find('[name="' + name + '"], [name="' + name + '[]"]').each(function () {
					if ($(this).is('select')) {
						const selectedValue = String($(this).val() || '');
						$(this).find('option').each(function () {
							if (!this.value) return;
							const optionValue = String(this.value);
							$(this).prop('disabled', !values.includes(optionValue) && optionValue !== selectedValue);
						});
						return;
					}
					if (!this.value) return;
					const isChecked = (this.type === 'checkbox' || this.type === 'radio') && this.checked;
					const enabled = values.includes(String(this.value)) || isChecked;

					$(this).prop('disabled', !enabled);
					$(this).closest('.jobs-check').toggleClass('is-disabled', !enabled);
				});
			});

			refreshJobsSelects();
		}

		$heroForm.on('submit', function (event) {
			event.preventDefault();
			appliedSearchValue = $heroForm.find('[name="q"]').val() || '';
			loadJobs({includePendingSearch: true});
		});

		$filterForm.on('submit', function (event) {
			event.preventDefault();
			loadJobs();
			$filters.removeClass('is-open');
		});

		$filterForm.on('input', 'input[type="number"]', function () {
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(function () {
				loadJobs();
			}, 450);
		});

		$forms.on('change', 'select', function () {
			syncSharedFields(this);
			updateClearState();
			if ($(this).closest('.jobs-filter-form, .jobs-sort').length || $(this).is('[data-jobs-sort]')) {
				loadJobs();
			}
		});

		$heroForm.on('cityAutocomplete:clear', 'select[name="city_id"]', function () {
			syncSharedFields(this);
			updateClearState();
			loadJobs();
		});

		$filterForm.on('change', 'input[type="checkbox"]', function () {
			renderSkillChips();
			updateClearState();
			loadJobs();
		});

		$('[data-jobs-sort]').on('change', function () {
			loadJobs();
		});

		$loadMore.on('click', function () {
			if (!this.disabled && !$loadMore.hasClass('is-hidden')) {
				loadJobs({append: true});
			}
		});

		$(document).on('click', '.js-jobs-clear', function () {
			if (!this.disabled) clearFilters();
		});

		$('[data-jobs-filters-open]').on('click', function () {
			$filters.addClass('is-open').find('input, select, button').filter(':visible').first().trigger('focus');
		});
		$('[data-jobs-filters-close]').on('click', function () {
			$filters.removeClass('is-open');
		});
		$filters.on('click', function (event) {
			if (event.target === this) $filters.removeClass('is-open');
		});
		$(document).on('keydown', function (event) {
			if (event.key === 'Escape') $filters.removeClass('is-open');
		});

		$('[data-jobs-skill-search]').on('focus input', function () {
			const query = $(this).val().toLowerCase().trim();
			const $options = $('[data-jobs-skill-options]').addClass('is-open');

			$options.find('[data-skill-name]').each(function () {
				$(this).toggle($(this).data('skill-name').indexOf(query) !== -1);
			});
		});

		$(document).on('click', '.jobs-skill-chip', function () {
			const id = String($(this).data('skill-id'));
			$('[data-jobs-skill-options] input[name="skills[]"]').filter(function () {
				return String(this.value) === id;
			}).prop('checked', false).trigger('change');
		});

		$(document).on('click', function (event) {
			if (!$(event.target).closest('.jobs-select-dropdown').length) {
				$('.jobs-select-dropdown .dropdown-list').hide();
			}
			if (!$(event.target).closest('[data-jobs-skill-search], [data-jobs-skill-options], [data-jobs-skill-chips]').length) {
				$('[data-jobs-skill-options]').removeClass('is-open');
			}
		});

		window.addEventListener('popstate', function () {
			const params = new URLSearchParams(window.location.search);
			setControlsFromParams(params);
			loadJobs({push: false});
		});

		initJobsSelects();
		applyAvailability($page.data('available') || {});
		renderSkillChips();
		updateClearState();
	});
})(jQuery);
